module.exports = __webpack_public_path__ + "static/media/Floor-right.a57c14f8.png";